import React, { useState } from 'react';
import { Button, Modal, Toast } from 'antd-mobile';
import { Radios } from '../../components';
import * as Api from "../../../../api/order";
import { WalletRechargeMap } from '../../utils/const';

import '../../index.css';

const confirmTitle = '请确认将自动充值金额到用户账户'
const cancelTitle = '请确认将取消本次充值，将无法再次发起'

function WalletRechargeModal (props) {
  const { info, fetchBack } = props;

  const [status, setStatus] = useState(1);
  const [loading, setLoading] = useState(false);

  const [alertModalShow, setAlertModalShow] = useState(false);

  const handleWallet = () => {
    const data = {
      Id: info.Id,
      Status: status,
    };
    setAlertModalShow(false);
    setLoading(true);

    Api.ConfirmWalletTransaction(data)
      .then((res) => {
        if (res && res.RetCode === 0) {
          setLoading(false);
          Toast.success('钱包充值成功');
          fetchBack();
        } else {
          Toast.fail(res.Message, 3);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const AlertPanelShow = ({ status }) => {
    return (
      <Modal
        visible={alertModalShow}
        transparent
        maskClosable={false}
        onClose={() => {
          setAlertModalShow(false);
        }}
        title={status === 1 ? confirmTitle : cancelTitle}
        footer={[
          {
            text: '关闭',
            onPress: () => {
              setAlertModalShow(false);
            },
          },
          {
            text: status === 1 ? '确认充值' : '取消充值',
            onPress: () => {
              handleWallet();
            },
          },
        ]}
        afterClose={() => { }}
      >
      </Modal>
    );
  };

  return (
    <>
      <div>
        <span>操作：</span>
        <Radios
          value={status}
          onChange={(value) => setStatus(value)}
          options={Object.keys(WalletRechargeMap).map((item) => ({
            label: WalletRechargeMap[item],
            value: +item,
          }))}
        />
      </div>
      <Button
        type="primary"
        style={{ marginTop: '30px' }}
        onClick={() => {
          setAlertModalShow(true);
        }}
        loading={loading}
      >
        确认
      </Button>
      <AlertPanelShow status={status} />
    </>
  );
}

export default WalletRechargeModal;
